import { BadgeBetaComponent } from './badge-beta.component';

export default angular
  .module('sfMobile.components.badge-beta', [])
  .component('sfBadgeBeta', BadgeBetaComponent).name;
